export default __webpack_public_path__ + "static/media/logo_vertical.781bcb87.svg";